import { render, staticRenderFns } from "./NovaAssinaturaPF.vue?vue&type=template&id=b593c4aa&"
import script from "./NovaAssinaturaPF.vue?vue&type=script&lang=js&"
export * from "./NovaAssinaturaPF.vue?vue&type=script&lang=js&"
import style0 from "./NovaAssinaturaPF.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports